import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { API_BASE_URL } from "../config/config";

export const useUserSession = () => {
  const [loading, setLoading] = useState(true);
  const [userDetails, setUserDetails] = useState(null);
  const navigate = useNavigate();

  const refreshUser = useCallback(async () => {
    const token = localStorage.getItem("care_token");
    if (!token) {
      navigate("/login");
      return null;
    }

    const tokenData = jwtDecode(token);
    const currentTime = new Date().getTime();
    if (currentTime > tokenData.expiry) {
      localStorage.removeItem("care_token");
      navigate("/login");
      return null;
    }

    const response = await axios.get(`${API_BASE_URL}/user`, {
      params: {
        userId: tokenData.userId,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setUserDetails(response.data.user);
    return response.data.user;
  }, [navigate]);

  useEffect(() => {
    const loadUser = async () => {
      try {
        await refreshUser();
      } catch (error) {
        console.error("Error loading user session:", error);
        localStorage.removeItem("care_token");
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, [navigate, refreshUser]);

  return { loading, userDetails, setUserDetails, refreshUser };
};
